// this should be Array<string>, string -

/* if i pass "can i edit plans", "can i edit overrides" and "can i edit members",
   and only members returns yes, ill get yes for all three */

// the api will still stop the frontend cold but it should probably either be:

/* 1. checking one permission at a time
   2. returning false if anything is not present */

/**
 * @deprecated This function is deprecated and the new shell hooks should be used instead.
 */
function checkPermissions(userPermissions: ReadonlyArray<string>, requiredPermissions: ReadonlyArray<string>): boolean {
  let access = false;
  const intersection = userPermissions.filter((value) => requiredPermissions.includes(value));

  if (intersection && intersection.length) {
    access = true;
  }

  return access;
}

export default checkPermissions;
